import React, { SVGProps } from 'react'
const SvgBudgetUnselected = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || '#697080'}
      d="m13.9 13.116 4.237 2.46a.759.759 0 0 1 .064.041 6.811 6.811 0 0 0-.594-6.595 6.798 6.798 0 0 0-4.896-2.943.761.761 0 0 1 .002.053l-.01 1.166.018 5.124 1.178.694Zm4.075 4.142a7.449 7.449 0 1 1-6.78-11.842v-.125a.75.75 0 0 1 .748-.752 8.313 8.313 0 0 1 7.194 12.533.75.75 0 0 1-1.027.266l-.135-.08Zm-4.833-2.847-1.615-.938a.75.75 0 0 1-.374-.655l.05-5.524-.002-.368a5.949 5.949 0 1 0 5.473 9.565l-3.532-2.08Z"
    />
  </svg>
)
export default SvgBudgetUnselected
